import Vue from 'vue'
import WooCommerceRestApi from '@woocommerce/woocommerce-rest-api';

const WC_API = new WooCommerceRestApi({
  url: process.env.VUE_APP_WC_URL, 
  consumerKey: process.env.VUE_APP_WC_USER,
  consumerSecret: process.env.VUE_APP_WC_PASS,
  version: 'wc/v3',
  axiosConfig: { headers: {} }
});

export default Vue.prototype.$woocommerce = WC_API;